import {loadStripe} from '@stripe/stripe-js';
import axiosInstance from "../Axios/AxiosConfig";
import URLS from "../Axios/URLS";

let stripePromise;
const getStripePromise = () => {
    if (!stripePromise) {
        axiosInstance.get(URLS.stripPublicKey).then((res) => {
            stripePromise = loadStripe(res?.data?.data?.publicKey);
        })
    }
    return stripePromise;
};

stripePromise = getStripePromise();
export default getStripePromise